import { Component, HostBinding, HostListener, Input, OnInit } from '@angular/core';
import { StaticService } from '../../../services/static/static.service';
import { MStaticClient, MStaticInter, MStaticFilter, MUser, MSelector } from '@argalis-apps/models';
import { AccountConfigService } from '../../../services/account-config/account-config.service';
import { ConfigService } from '@argalis-apps/angular-global';
import { AuthService } from '../../../../auth/services/auth/auth.service';
import { SelectorService } from '../../../services/selector/selector.service';

@Component({
  selector: 'argalis-apps-static-list-card',
  templateUrl: './static-list-card.component.html',
  styleUrls: ['./static-list-card.component.scss']
})
export class StaticListCardComponent implements OnInit {
  @HostBinding('class') themeFlag: string;
  public getMoreFilter = true;
  public selectPeriodChecker = false;
  public indicator = false;
  public listOfPeriod: MStaticFilter.IDateSetPeriod[] = [
    { id: '1', libelle: 'Année en cours', code: MStaticFilter.ECode.ANN },
    { id: '2', libelle: 'Semestre en cours', code: MStaticFilter.ECode.SEM },
    { id: '3', libelle: 'Trimestre en cours', code: MStaticFilter.ECode.TRI },
    { id: '4', libelle: 'Mois en cours', code: MStaticFilter.ECode.MOIS },
    { id: '5', libelle: 'Personnalisé', code: MStaticFilter.ECode.PER }
  ];
  public dateBeginPeriod: Date;
  public dateEndPeriod: Date;
  public listProduits: MSelector.IProduit[];
  public listSector: MSelector.ISector[];
  public listGroup: MSelector.IFamile_Group_Site[];
  public listSite: MSelector.IFamile_Group_Site[];
  public listFamile: MSelector.IFamile_Group_Site[];
  public data: MStaticClient.IStaticClientInfo | MStaticInter.IStaticInterInfo;
  public staticRequest: MStaticClient.IStaticClientRequest | MStaticInter.IStaticInterRequest = {} as
    | MStaticClient.IStaticClientRequest
    | MStaticInter.IStaticInterRequest;
  public statut_session: MSelector.IStatut_Session[];
  public isInter: boolean;
  public isBigScreen: boolean;
  public cardVisualisation: MStaticInter.IStatistiqueCardVisualisationInter;
  public id: number;
  public userConnected: MUser.CUser;

  constructor(
    private staticService: StaticService,
    private accountConfigService: AccountConfigService,
    private authService: AuthService,
    private configService: ConfigService,
    private selectorService: SelectorService
  ) {
    this.isInter =
      this.configService
        .getETypeUser()
        .valueOf()
        .valueOf() === MUser.ETypeUser.FORMATEUR.valueOf();
    this.changeDate(MStaticFilter.ECode.ANN);
    this.getListStatut_session();
    this.userConnected = this.authService.userConnected;
    this.authService.userChange.subscribe((user: MUser.CUser) => {
      if (user && !user.login) this.userConnected = null;
      else this.userConnected = Object.assign({}, user);
    });
    this.id = this.userConnected.userInfo.id;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    this.isBigScreen = event.target.innerWidth >= 992;
  }

  moreFilter() {
    this.getMoreFilter = !this.getMoreFilter;
  }

  changePeriod(selectPeriod: MStaticFilter.IDateSetPeriod) {
    if (selectPeriod.code.valueOf() !== MStaticFilter.ECode.PER.valueOf()) {
      this.changeDate(selectPeriod.code);
      this.getStatic();
    } else {
      this.selectPeriodChecker = true;
    }
  }

  private changeDate(code: MStaticFilter.ECode) {
    const period = this.staticService.changeDate(code);
    this.dateBeginPeriod = new Date(period.dateBeginPeriode);
    this.dateEndPeriod = new Date(period.dateEndPeriod);
    (
      this.staticRequest || ({} as MStaticClient.IStaticClientRequest | MStaticInter.IStaticInterRequest)
    ).dateDebutPeriode = (period || ({} as MStaticFilter.CPeriod)).dateBeginPeriode;
    (
      this.staticRequest || ({} as MStaticClient.IStaticClientRequest | MStaticInter.IStaticInterRequest)
    ).dateFinPeriode = (period || ({} as MStaticFilter.CPeriod)).dateEndPeriod;
  }

  changeBeginDate(beginDate) {
    this.dateBeginPeriod = beginDate;
    this.staticRequest.dateDebutPeriode = this.staticService.parseDate(beginDate);
    this.getStatic();
  }

  changeEndDate(endDate) {
    this.dateEndPeriod = endDate;
    this.staticRequest.dateFinPeriode = this.staticService.parseDate(this.dateEndPeriod);
    this.getStatic();
  }

  selectStatut(statut_session: MSelector.IStatut_Session) {
    if (this.staticRequest.listeSessionStatut.indexOf(Number(statut_session.id || 0)) === -1) {
      this.staticRequest.listeSessionStatut.push(Number(statut_session.id));
    } else {
      this.staticRequest.listeSessionStatut = this.staticRequest.listeSessionStatut.filter(elem => {
        return elem !== Number(statut_session.id);
      });
    }
    this.getStatic();
  }

  getListProduits() {
    this.selectorService.getListProduit().subscribe(
      produit => {
        this.listProduits = produit;
      },
      () => {
        this.listProduits = [];
      }
    );
  }

  getListStatut_session() {
    this.selectorService.getListStatutSession().subscribe(
      statut_session => {
        if (statut_session) {
          this.statut_session = statut_session;
          this.staticRequest.listeSessionStatut = [];
          for (const elem in statut_session) {
            if (statut_session[elem].code === 'ANNULE') {
              break;
            }
            this.staticRequest.listeSessionStatut.push(Number(statut_session[elem].id));
          }
          this.getStatic();
        }
      },
      () => {
        this.staticRequest.listeSessionStatut = [];
        this.statut_session = [];
        this.getStatic();
      }
    );
  }

  getListSite() {
    this.selectorService.getListSite().subscribe(
      site => {
        this.listSite = site;
      },
      () => {
        this.listSite = [];
      }
    );
  }

  getListSector() {
    this.selectorService.getListSector().subscribe(
      sectors => {
        this.listSector = sectors;
      },
      () => {
        this.listSector = [];
      }
    );
  }

  getListGroup() {
    this.selectorService.getListGroup().subscribe(
      groups => {
        this.listGroup = groups;
      },
      () => {
        this.listGroup = [];
      }
    );
  }

  getListFamile() {
    this.selectorService.getListFamile().subscribe(
      familes => {
        this.listFamile = familes;
      },
      () => {
        this.listFamile = [];
      }
    );
  }

  getStatic() {
    this.staticService.getStaticInfo(this.isInter, this.staticRequest, this.id).subscribe(data => {
      if (data.ca) {
        this.data = data as MStaticClient.IStaticClientInfo | MStaticInter.IStaticInterInfo;
      }
    });
  }

  getCardVisualition() {
    this.staticService.getStaticInfoCard(this.isInter, this.id).subscribe(data => {
      this.cardVisualisation = data as MStaticInter.IStatistiqueCardVisualisationInter;
    });
  }

  chargeDropList() {
    this.getCardVisualition();
    this.getListProduits();
    this.getListSector();
    this.getListGroup();
    this.getListFamile();
    if (!this.isInter) this.getListSite();
  }

  getFilterSelector(list: any[], selectorType: string) {
    switch (selectorType) {
      case 'site':
        (this.staticRequest as MStaticClient.IStaticClientRequest).listeSite = [];
        (this.staticRequest as MStaticClient.IStaticClientRequest).listeSite = Array.from(
          new Set(
            (this.staticRequest as MStaticClient.IStaticClientRequest).listeSite.concat(
              list.map(elm => elm.id.toString())
            )
          )
        );
        this.getStatic();
        break;
      case 'produit':
        this.staticRequest.listeProduit = [];
        this.staticRequest.listeProduit = Array.from(
          new Set(this.staticRequest.listeProduit.concat(list.map(elm => elm.id.toString())))
        );
        this.getStatic();
        break;

      case 'secteur':
        this.staticRequest.listeProduitSecteur = [];
        this.staticRequest.listeProduitSecteur = Array.from(
          new Set(this.staticRequest.listeProduitSecteur.concat(list.map(elm => elm.id.toString())))
        );
        this.getStatic();
        break;
      case 'famille':
        this.staticRequest.listeProduitFamille = [];
        this.staticRequest.listeProduitFamille = Array.from(
          new Set(this.staticRequest.listeProduitFamille.concat(list.map(elm => elm.id.toString())))
        );
        this.getStatic();
        break;

      case 'groupe':
        this.staticRequest.listeProduitGroupe = [];
        this.staticRequest.listeProduitGroupe = Array.from(
          new Set(this.staticRequest.listeProduitGroupe.concat(list.map(elm => elm.id.toString())))
        );
        this.getStatic();
        break;
    }
  }

  ngOnInit() {
    this.chargeDropList();
    this.staticRequest.listeProduitSecteur = [];
    this.staticRequest.listeProduitFamille = [];
    this.staticRequest.listeProduitGroupe = [];
    this.staticRequest.listeProduit = [];
    if (!this.isInter) (this.staticRequest as MStaticClient.IStaticClientRequest).listeSite = [];
    this.themeFlag = `${this.themeFlag || ''} ${this.accountConfigService.themingClassName}`;
  }
}
